import HtmlContent from './HtmlContent'

export * from './HtmlContent'
export default HtmlContent
